import Icon from "components/Elements/Icon/Icon";
import Image from "components/Elements/Image/Image";
import ExampleElem from "./ExampleElem";
import { useContent } from "contexts/contentContext/contentContext";

import generalStyles from "../../styles.module.scss";
import styles from "./styles.module.scss";

const GALLERY_EXAMPLES = [
  {
    name: "gallery-cover-1",
    link: "https://picker-new.jumbomail.me/avielpelagi2797/pr/?idc=TE1Rajd1aVFDaFBReUZrUGx3MmN2UT09&pixelect",
    title: "Kate & Jacob",
    subTitle: "Love Story",
  },
  {
    name: "gallery-cover-2",
    link: "https://picker-new.jumbomail.me/canvalab8377/pr/?pixelect&idc=MXRZMlVjbnlaVllQcTAyc1VSREQ3QT09",
    subTitle: "Magazine Shooting",
  },
  {
    name: "gallery-cover-3",
    link: "https://picker-new.jumbomail.me/alanjackson1971/pr/?pixelect&idc=TDlxS2pUODRvUW15dEhKalRSMWxVdz09&lang=en",
    title: "MR & MRS",
    subTitle: "The wedding day",
  },
  {
    name: "gallery-cover-4",
    link: "https://picker-new.jumbomail.me/highschool3633/pr/?pixelect&idc=ZmlLdGhkamp3bXlDWGdPZ1NUVG5Bdz09",
    title: "Starkiddo",
    subTitle: "Summer collection",
  },
];

export const ThirdSection = () => {
  const { getHtmlByKey } = useContent();

  return (
    <section className={styles.section}>
      <div className={styles.columntSection}>
        <div className={styles.imageContainer}>
          <Image name="picker/customize-gallery" ext={"gif"} />
        </div>
        <h3 className={`${generalStyles.titleDark} ${styles.textCentered}`}>
          {getHtmlByKey("picker-section-3-title")}
        </h3>
        <p
          className={`${generalStyles.textDark} ${styles.paddingInline} ${styles.textCentered}`}
        >
          {getHtmlByKey("picker-section-3-text")}
        </p>
        <div className={styles.examplesText}>
          {getHtmlByKey("picker-section-3-sub-text")}
          <Icon name="arrow-down" gray />
        </div>
      </div>
      <div className={styles.rowSection}>
        {GALLERY_EXAMPLES.map((example) => (
          <ExampleElem {...example} key={example.name} />
        ))}
      </div>
    </section>
  );
};

export default ThirdSection;
